import React, {FC} from "react";
import {UserIncident} from "../../../../domain/incident/Incident";
import {toTime} from "../../../../lib/date";

type Props = {
    item: UserIncident;
};

export const IncidentRowTimestamp: FC<Props> = ({item}) => {
    const {timestamp} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>REGISTRADO EL</span>
            <span>{toTime(timestamp)}</span>
        </div>
    );
};
